const STEPS = [
  {
    n: "01",
    t: "Tell us your situation",
    d: "Text us or complete the free form. One of our licensed homeowner advocates reviews your case — no obligation.",
  },
  {
    n: "02",
    t: "We build your custom plan",
    d: "Within 24 hours we return with 2–3 tailored options, including pros, cons, timelines, and estimated outcomes.",
  },
  {
    n: "03",
    t: "Choose your path",
    d: "Keep the home, sell on your terms, or recover surplus funds. You choose — we never pressure you.",
  },
  {
    n: "04",
    t: "We handle the heavy lifting",
    d: "Paperwork, lender negotiations, buyer matching, court filings — we manage the process so you can move forward.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="mb-4">
            <span className="gold-rule" />
            <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
              How it works
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight">
            A clear path — from crisis to control.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className="relative rounded-lg border border-[#E5E3DB] p-8 bg-[#FAF9F6] hover:bg-white hover:border-[#C5A059]/40 transition-all"
            >
              <div className="font-display text-5xl text-[#C5A059]/70 mb-4 leading-none">
                {s.n}
              </div>
              <div className="h-px w-10 bg-[#0B1B3D]/20 mb-4" />
              <h3 className="font-display text-xl text-[#0B1B3D] mb-2">{s.t}</h3>
              <p className="text-sm text-[#64748B] leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
